// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"fae64ea9c2c7f959357e","303":"c7e14202893c174e4f63","495":"0d2d22744c2eaf339923"}[chunkId] + ".js";
};